module.exports = __webpack_public_path__ + "static/heroOlympo34-c8b936ee627833911e3ffb9eb05b05ef.png";